// Blocked-work bar — FE-032 / spec §7.0.2.
//
// Per-staff count of blocked Commitments where the staffer is the
// assignee or the reviewer of a blocked record waiting on review.
// Each row drills through to the Commitment Tracker pre-filtered to
// is_blocked=true plus assigned_to.

import {
  buildCommitmentFilterUrl,
  type DashboardDateRange,
  type EmployeeAnalyticsResponse,
} from "@/features/dashboard";
import { formatStaffName } from "@/features/dashboard/staffPerformance";

import { DashboardSectionHeader } from "../primitives";

import { HorizontalBar, type HorizontalBarRow } from "./HorizontalBar";

interface BlockedWorkBarProps {
  rows: EmployeeAnalyticsResponse["blocking_bar"];
  dateRange: DashboardDateRange;
}

export function BlockedWorkBar({ rows, dateRange }: BlockedWorkBarProps) {
  const sorted = [...rows].sort(
    (a, b) => b.blocked_count - a.blocked_count,
  );
  const barRows: HorizontalBarRow[] = sorted.map((row) => {
    const name = formatStaffName(row);
    return {
      id: row.user_id,
      label: name,
      value: row.blocked_count,
      barClassName: "bg-blocked",
      href: buildCommitmentFilterUrl(
        { assigned_to: row.user_id, is_blocked: true },
        dateRange,
      ),
      ariaLabel: `${name} has ${row.blocked_count} blocked Commitments`,
    };
  });
  return (
    <section
      data-testid="blocked-work-bar"
      aria-labelledby="blocked-work-bar-heading"
    >
      <DashboardSectionHeader
        title={
          <span id="blocked-work-bar-heading" className="text-sm font-semibold">
            Blocked work
          </span>
        }
        subtitle="Who is blocking the most Commitments?"
      />
      <div className="mt-2">
        <HorizontalBar
          rows={barRows}
          emptyLabel="Nothing is blocked right now."
        />
      </div>
    </section>
  );
}
